<template>
  <tr>
    <td v-for="(columData, index) in row" is="column-data" :key="`${row ? row.id : ''}-${index}`" :column="index" :data="columData" :headers="headers"></td>
  </tr>
</template>

<script>

  import DataColumn from './DataTableColumn'
  
  export default {
    
    components: {
      'column-data': DataColumn
    },
    
    props: {
      row: {
        type: Object,
        required: true
      },
      headers: {
        type: Array,
        default() {
          return []
        }
      }
    },

  }

</script>
